import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ReportsAPI from '../../../src/API/ReportsAPI';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SnackbarAlert from '../Utils/SnackbarAlert';
import GlobalIcon from '@material-ui/icons/Public';
import CommercialIcon from '@material-ui/icons/Group';
import PeopleReservationIcon from '@material-ui/icons/AssignmentInd';
import ActiveReservationIcon from '@material-ui/icons/AssignmentTurnedIn';
import FullScreenLoading from '../Utils/FullScreenLoading';
import ReportIcon from '@material-ui/icons/Report';
import { handleServerError } from '../../Utils/Helper';
import { REPORT_GLOBAL_STOCK, REPORT_COMMERCIAL_STOCK, REPORT_RESERVATIONS_BY_STATE, REPORT_ACTIVE_RESERVATIONS, REPORTS_GLOBAL_GROUP, GENERAL_GROUP, UR_GENERAL_GROUP, REPORT_NOLS } from '../../Utils/Constants';


const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  divToolbar: {
    paddingLeft: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  width100: {
    width: '100%'
  },
  button: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  }
});


export class ReportsContent extends Component {
  reportsDataAPI;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      urlDownload: '',
      openError: false,
      alertMessage: ''
    }
    this.reportsDataAPI = new ReportsAPI();
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      loading: false,
      urlDownload: '',
      openError: false,
      alertMessage: ''
    });
  };

  handleClickGetReport = (reportId) => {
    this.setState({ loading: true });
    this.reportsDataAPI.getReport(reportId).then((success) => {
      this.setState({
        loading: false,
        urlDownload: success.request.responseURL
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
    this.setState({
      urlDownload: ''
    });
  };


  render() {
    const { classes } = this.props;
    const { loading } = this.state;

    return (
      <Paper className={classes.paperRoot}>

        <div className={classes.divToolbar}>
          <Typography variant='title' id='tableTitle'>
            RELATÓRIOS
          </Typography>
        </div>

        <iframe title='openExcelReports' style={{ display: 'none' }} src={this.state.urlDownload}></iframe>

        <ExpansionPanel defaultExpanded={true}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography color='primary' variant='subheading' className={classes.heading}>GESTÃO DE STOCK</Typography>
          </ExpansionPanelSummary>

          <ExpansionPanelDetails>
            <Grid container spacing={32}>
              {this.props.roleTypes.indexOf(REPORTS_GLOBAL_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <Grid item xs={12} sm={6}>
                  <Button color='primary' variant='contained' className={classes.width100} onClick={() => this.handleClickGetReport(REPORT_GLOBAL_STOCK)} >
                    <GlobalIcon className={classes.button} />
                    Stock Global
                  </Button>
                </Grid>
                : null
              }
              <Grid item xs={12} sm={6}>
                <Button color='primary' variant='contained' className={classes.width100} onClick={() => this.handleClickGetReport(REPORT_COMMERCIAL_STOCK)} >
                  <CommercialIcon className={classes.button} />
                  Stock Comercial
                </Button>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>

        </ExpansionPanel>


        <ExpansionPanel defaultExpanded={true}>

          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography color='primary' variant='subheading' className={classes.heading}>GESTÃO DE RESERVAS</Typography>
          </ExpansionPanelSummary>

          <ExpansionPanelDetails>
            <Grid container spacing={32}>
              <Grid item xs={12} sm={6}>
                <Button color='primary' variant='contained' className={classes.width100} onClick={() => this.handleClickGetReport(REPORT_RESERVATIONS_BY_STATE)} >
                  <PeopleReservationIcon className={classes.button} />
                  Reservas por estado / Gestor
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button color='primary' variant='contained' className={classes.width100} onClick={() => this.handleClickGetReport(REPORT_ACTIVE_RESERVATIONS)} >
                  <ActiveReservationIcon className={classes.button} />
                  Reservas Ativas
                </Button>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel defaultExpanded={true}>

          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography color='primary' variant='subheading' className={classes.heading}>LIGAÇÃO AO NOLS</Typography>
          </ExpansionPanelSummary>

          <ExpansionPanelDetails>
            <Grid container spacing={32}>
              <Grid item xs={12} sm={6}>
                <Button color='primary' variant='contained' className={classes.width100} onClick={() => this.handleClickGetReport(REPORT_NOLS)} >
                  <ReportIcon className={classes.button} />
                  Veículos com ligações a "False"
                </Button>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

        {loading && <FullScreenLoading />}

      </Paper>
    )
  }
}

export default ReportsContent = withStyles(styles)(ReportsContent);


// WEBPACK FOOTER //
// ./src/components/Reports/ReportsContent.js